module.exports = __webpack_public_path__ + "static/interaction-1-5-72ad21fbfbd954c127d9c9f3964ff728.png";